module.exports = __webpack_public_path__ + "media/images/application/template/meganav/shipping-containers/40ft-e8c7fa80e4b0664f5824ed12d23ce149.png";